module.exports = __webpack_public_path__ + "img/大数据平台数据分析2.ebeb622b.jpg";